import React from "react";

const SalesIcon = (props) => {
    const {size, marked,style} = props;
    return(
        <svg 
            xmlns="http://www.w3.org/2000/svg"  
            viewBox="0 0 48 48" 
            width={size} 
            height={size}
            marked={marked}
            style={style}
        >
            <path 
                fill={marked===1 ? "black" : "black"}
                d="M 24 4 C 12.972066 4 4 12.972074 4 24 C 4 35.027926 12.972066 44 24 44 C 35.027934 44 44 35.027926 44 24 C 44 12.972074 35.027934 4 24 4 z M 24 7 C 33.406615 7 41 14.593391 41 24 C 41 33.406609 33.406615 41 24 41 C 14.593385 41 7 33.406609 7 24 C 7 14.593391 14.593385 7 24 7 z M 23.476562 10.978516 A 1.50015 1.50015 0 0 0 22 12.5 L 22 13.652344 C 19.207791 14.038344 17 16.357587 17 19.25 C 17 22.407822 19.592178 25 22.75 25 L 24.75 25 C 26.562096 25 28 26.437904 28 28.25 C 28 30.062096 26.562096 31.5 24.75 31.5 L 22.5 31.5 C 21.322258 31.5 20.358942 30.70345 20.080078 29.632812 A 1.50015 1.50015 0 1 0 17.177734 30.388672 C 17.752415 32.595033 19.686351 34.197787 22 34.416016 L 22 35.5 A 1.50015 1.50015 0 1 0 25 35.5 L 25 34.449219 C 28.313006 34.309282 31 31.595439 31 28.25 C 31 24.816096 28.183904 22 24.75 22 L 22.75 22 C 21.213822 22 20 20.786178 20 19.25 C 20 17.713822 21.213822 16.5 22.75 16.5 L 23.253906 16.5 A 1.50015 1.50015 0 0 0 23.740234 16.5 L 24.5 16.5 C 25.669144 16.5 26.62787 17.286788 26.914062 18.345703 A 1.5002527 1.5002527 0 1 0 29.810547 17.5625 C 29.220588 15.379651 27.296986 13.800333 25 13.583984 L 25 12.5 A 1.50015 1.50015 0 0 0 23.476562 10.978516 z"
            />    
        </svg>
    )
}

export default SalesIcon;

